// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","machineTypeImg":"machineTypeSelectFilter_machineTypeImg__KgRuK"};